import { DateRangePicker as TremorDateRangePicker } from '@tremor/react';
import React from 'react';

export default function DateRangePicker(props) {
    const {
        value,
        onValueChange,
        placeholder = "Select date range",
        enableSelect = true,
        maxDate,
        minDate,
        className,
        disabled = false,
    } = props;

    return (
        <TremorDateRangePicker
            value={value}
            onValueChange={onValueChange}
            placeholder={placeholder}
            enableSelect={enableSelect}
            maxDate={maxDate}
            minDate={minDate}
            className={className}
            disabled={disabled}
        />
    );
} 